import { AudienceSourceType, ConditionSourceType } from '../models';

export const BranchingLogicHelper = {
	getAttributeSourceType: (audienceSourceType: AudienceSourceType | undefined) => {
		return audienceSourceType === AudienceSourceType.Hris ? ConditionSourceType.HrisAttribute : ConditionSourceType.FileAttribute;
	},
	getNodeValues: (valueText?: string): { displayText: string; count: number }[] => {
		if (!valueText) {
			return [];
		}

		const nodeValue = JSON.parse(valueText);
		const parsedValues: { displayText: string; count: number }[] =
			Object.keys(nodeValue.singleIncluded)?.map((key) => {
				return {
					displayText: nodeValue.singleIncluded[key].name,
					count: nodeValue.singleIncluded[key].totalRollups,
				};
			}) || [];
		return parsedValues.concat(
			Object.keys(nodeValue.descendantsIncluded)?.map((key) => {
				return {
					displayText: nodeValue.descendantsIncluded[key].name,
					count: nodeValue.descendantsIncluded[key].totalRollups,
				};
			}) || [],
		);
	},
};
